import React from 'react'

interface PageIndicatorProps {
	pageName?: string;
}

const PageIndicator: React.FC<PageIndicatorProps> = (props) => {
	return (
		<div className="right">
			<hr className="top" />
			<p className="text no-select">{props.pageName ?? "Home"}</p>
			<hr className="bottom" />
		</div>
	)
}

export default PageIndicator;